import { FormGroup, Label, Col, Input, FormFeedback } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import React from 'react'

const FieldSelect = ({ title, value, className = null, options = [], name, onChange, disabled = false, error }) => (
  <FormGroup row>
    <Col sm='4' className={className}>
      <Label>{I18n.t(title)}</Label>
    </Col>

    <Col sm='8'>
      <Input bsSize='sm' type='select' name={name} value={value || ''} onChange={onChange} disabled={disabled} invalid={error}>
        <option value=''>{I18n.t(title)}</option>
        {options.map((elem, idx) => (
          <option key={idx} value={elem.value || elem}>
            {I18n.t(elem.label || elem)}
          </option>
        ))}
      </Input>
      <FormFeedback>{error ? I18n.t('dashboard_errors_required-field') : ''}</FormFeedback>
    </Col>
  </FormGroup>
)

export default FieldSelect
